var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M.3 0H23v16H.3zM31 24h22.7v16H31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M.3 24H23v16H.3zM31 0h22.7v16H31z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#201b18",
    d: "M26 16.4a3 3 0 0 0-1.6.4q-.4.1-.2.4H24l-.5.3-.2.2h.5l-.3.4.4-.3 1.1-.4V17l.5-.1h1l.2-.2v-.2h.8q-.1.2.1.3h1.1l.5.2v.3l.1.1.5.2c.5 0 .5.1.9.4l-.3-.5h.5l-.5-.2-.5-.2v-.3l-.6-.3-.6-.2H28V16h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "m26 16.7.2-.1h1.7l.1-.3q0-.2-.2-.2H26l-.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "m24.4 17.4.2-.2.8-.3h1.1v-.1h-.4v-.2l-.2-.2-1.2.3-.5.2v.3zm3-.6.2.1h1l.5.2.4.2.2-.1v-.3l-.4-.2-.7-.2H28l-.1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "m29 17.3.2.1 1 .3q0 .2.3.2l-.2-.3h.4q-.4-.3-1-.4l-.2.3-.2-.1zm-1.6-.6.3.1h.2q0-.2-.2-.2h-.2zm-.8 0v-.1c-.1 0-.6 0-.5.1v.1zm-2.1.7.3-.1h.1V17l-.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M29 17.2h.2q0 .3.3.2l-.1-.1zm-4 0-.2.2-1 .4-.3.1.2-.3h-.4q.4-.3 1-.4v.1l.1.2h.1l.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "M25 16.7h-.1v.2h.2zm0 0v.2zm.1-.1v.2h.1zm.2 0h.1v-.2m0 0 .1.1v.1zv-.1m.2 0h.1v.2h.1v-.2zv-.1m1-.5h-.1v.3h.1zm0 0v.2zm.2 0v.3h.1zm.2.1v.2zm.3 0H27v.2zh.1v.1zm.2 0v.2zm.2 0-.1.1zm.5.3v.3h.2-.1zm.2.3v-.3zm.1-.3v.3h.2v-.3zm.2.3h.2zv-.2h.1-.1zm.3-.2v.3-.1.1h.1v-.2zm.2.1v.3-.1l.1-.2v.1zm.3 0-.2.2h.1v.1zm.1.2v.2h-.1v.1h.2zm0 0 .1.1v.1l-.1.1v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "M26 23.3h.3l.1.3h.1l-.3.2v.2h.2l.5-.3.1-.1.7.3h.2l-.4-.2.2-.3.2-.1c0-.2-1.5-.3-1.8 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M27.7 23.9h.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "m29.1 18 .2.5-.2-.4v.2l.3.6v-.1l-.2-.1v-.3l-.2-.2v.4-.1h-.1v.1l.2.2.2.3v.1-.1l-.4-.3h.1l.2.3.2.2.1.2-.3-.3-.2-.2-.1-.1.2.3h.1l.1.2.2.3-.3-.3-.2-.1.3.3.3.3v.2l-.2-.3-.2-.2-.2-.1.1.1.3.3.1.2V20h-.1l-.1-.2-.3-.1.3.2v.1l.2.1v.2l.1.1.2.4-.2-.4q0-.2-.2-.2h-.1l-.2.2v.4l.1-.4v.5-.1l.1-.3.2.7V21l-.2-.2-.1.1H29v.4-.4l.2.4q0 .3-.3.7v.1l-.1.1.1-.3.1-.4v-.1l-.4 1V22l-.2.4v-.1l.1-.3-.1.3v-.2.1l-.3.4.5.1h.8-.2l-.2-.1h.6l-.6-.1h.6l.2-.1h-.4.7l-.5-.2.2-.1.4-.1q.4-.1.1-.1H30h.1l.3-.1.6-.2h-.7l.4-.1h.2-.6l.7-.1h-.4l.2-.2h.3l-.2-.1V21l.1-.1-.2.1-.3.1.2-.2h.2l.1-.1h-.3l-.2.2.5-.5-.3.2-.3.2.2-.2.1-.1.2-.2.2-.2-.4.3h-.2l-.1.2.2-.3.4-.4-.5.3v.1l-.2.2-.2.3q0-.3.3-.4l.2-.3q.3-.2.3-.5l-.1.1v.1l-.5.5.1-.3.5-.6.2-.2-.3.1-.5.5.2-.4.2-.3.1-.2v.1h-.1l-.4.7.2-.4.2-.4-.2.2-.2.2-.2.5.2-.6.2-.2.1-.2v-.1l-.2.2-.2.3.2-.4.2-.2v-.1l-.3.3-.1.1v.2H30V19l.3-.4-.2.2-.1.2.2-.6v.1l-.3.3.2-.3-.3.5v.1-.7.3l-.2.3q0-.3-.3-.7zm.2 2.8.1.6v-.1l-.1-.3v.1q-.1-.2 0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.1 22.7.2-.4V22v.3l.2-.3v.3-.2l.1-.1v.3l.4-1v.5l-.3.4.1-.2.1-.1.3-.7-.1-.4v.4L29 21v-.3l.2.1v-.1l.2.2.1.2c0-.1 0-.6-.2-.7l-.1.3v-.4l-.1.3v.1-.4l.2-.1v-.1l.3.2.2.4-.2-.4v-.1l-.1-.2-.1-.1h-.1l-.2-.2-.1-.1.3.1v.1h.1l.1.2-.1-.2-.3-.3v-.1l.3.3h.1l.1.3v-.2l-.2-.2-.1-.1-.3-.3h.2l.4.5-.1-.2-.2-.2v-.1l-.2-.1-.2-.3.1.1.2.2.2.3h.1l-.1-.2-.2-.2-.2-.2v-.1l.2.3.2.1h-.1l-.2-.4-.1-.2-.1-.2v.1l.2.1v-.3.1l.1.3.1.1h.1l-.3-.5V18q0 .2.2.3v.1l-.2-.5q.2 0 .2.2l.3.7.1-.3v-.2h.1v.6-.1l.3-.5-.2.3.2-.3h.1l-.2.5.1-.2.2-.2-.2.4-.1.4.1-.2.4-.4-.2.3-.2.4.2-.3.3-.2-.1.1v.1h-.1l-.2.3-.2.6.2-.5.2-.2.2-.2-.2.4-.2.4.4-.7h.1l-.1.1-.2.3-.2.4.5-.5h.3-.1l-.1.1-.6 1 .4-.6.2-.2q0 .3-.3.5l-.2.3-.3.4.4-.5.4-.4h.2-.1l-.4.4-.2.3.1-.1.2-.1.4-.3-.1.1h-.1q0 .2-.2.3h-.1l-.2.3.3-.2.3-.2-.5.5.2-.1.3-.1h-.1l-.2.1-.2.2h.3l.2-.2v.2h-.2l-.2.3h.5-.1c-.5 0-.3 0-.7.2h.1l.4-.2-.5.3h.2l.5-.1-.6.2H30l-.1.1h.4q.2 0 0 0l-.5.2-.2.1.5.1h-.7l.4.1H29l.5.1H29l.2.1.2.1zm1.2-1.9.1.6v-.1l-.1-.3v.1q-.1-.2 0-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f4c",
    d: "M29.9 20.4c0-.3.4-1 .5-1l-.2.4-.3.8zm.8-.2-.1.2q-.6.5-.8 1.1-.3.5-.1.1.2-.7.8-1.2zm-1-.7q0-.4.2-.7l.2-.3-.4 1.2zm-.4 1.6-.2.8-.3.5a2 2 0 0 0 .5-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f4c",
    d: "M30 20.9v.4a1 1 0 0 1-.7.7 1 1 0 0 0 .7-1zv-.1m.8.7h-.4zm-1.5-3.3.2.5v.2l-.3-.8m-.2.2q0 .2.3.4l.2.1-.5-.7zm1.1.6c-.2.1-.5.7-.4.8l.2-.3zl.2-.1zm.1.1-.5 1 .2-.4.5-.7zm-1.2-.6q0 .3.2.5l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f4c",
    d: "M29.4 18.9h.2l-.6-.3h-.1zm1.3.7c-.3.2-.8 1-.8 1l.3-.3.7-.8zm0 .4-.8.8.3-.3.5-.6zm-1.8 2c0 .2-.4.8-.5.8l.2-.3zl.1-.2zm.8-1.6q0-.3-.4-.6zm.2 2.1H29h1zm-.3.1h-.9zm-.2.1-1 .1h1.1zm-.3.1h-.8zm1-.7q-1 0-1.2.3l.4-.1zm.6-.4-.5.1zm-.2 0h-.3zm-.1-.7c-.3.2-1 .8-1 1l.4-.4.8-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f4c",
    d: "M30.7 21.2c-.3 0-1 .4-1 .5l.3-.2zl.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f4c",
    d: "M30.7 21.2q-1.2 1.2-1.5 1l.6-.4zl.3-.3zm-.9.3.6-.6.4-.2h-.1l-1 1zm.1-.9c0-.3.6-1.3.7-1.3l-.2.4-.3.6-.2.6zm-.2-1.2v-.8 1zm.1 1.2q0-.3-.3-.5-.4-.3-.1 0zv.1zm-.8.2c.2-.6.3-.5.3-.5.4.4.2 1.6.2 1.6 0-2.5-.5-1-.5-1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f4c",
    d: "m29.2 20.8.2-.6c.3 0 .3 1.4.3 1.4-.2-2.3-.5-.8-.5-.8m-.2.5v-.4c.3.2.4 1 .4 1-.4-1.7-.4-.6-.4-.6m.7-1.3q-.1-.4-.5-.8t-.1 0q.3.2.6.8v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#008f4c",
    d: "M29.7 19.8q0-.4-.4-.7h-.1l.5.8zm-1.2 2.4-.2.4v-.1zm-.1 0q0 .4-.3.5l.1-.1zm.1 0-.2.5.1-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006300",
    strokeWidth: 0.1,
    d: "m23.8 20.4-.2-.2m.8 2.1c-.4-.4-.5-1.2-.5-1.2l.3-.4m-.3.4v-1L24 19m-.2 1.4q.3-.6.5-.4"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006300",
    strokeWidth: 0.1,
    d: "M23.8 20.4q.4-.4.4-.6l.1-.2m-.2 2.3v-.3m0 .2-.4-.2m.3-.7v-.3m0 1.1-.2-.3m.2-2.2-.1-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M23.8 21.3h-.1zm.1.4h-.2zm1.3.6H25m.3.1h-.1"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006300",
    strokeWidth: 0.1,
    d: "M24 20.8v-.1m1 1.7h.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "M25.2 22.7v-.3Zm-.6-.5v-.1l.3-.4h-.2v-.3l-.3.3-.1-.2v.6l.2.2m-.2.3q-.6-.1-.5-.3h.5zm-.3-.7h-.5q.3 0 .2.2.3.2.4.1h.1zm-.5-1.1-.5-.2.1.3h-.2l.3.3h.3l.3.2V21z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "m25.1 22.7-.1.1h-.5v-.1l-.2-.4h.4v-.1l.4.1zm-1.2-1.2h-.5l-.2-.3h.4l.1.2zm.2 0h.3l.3-.2v-.1h-.2V21q-.4.1-.3.2L24 21v.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "m25.7 22.3-.2.1-.3-.2v.3H25l.2.4.3-.1h.2zM24 20.9l.1.2h.6l-.2-.2zm-.3-.4.1-.6.2.5-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "m23.6 20.5-.4-.2h.4l.3.2zm-.2-.3h-.2l-.2-.4h.2c-.3-.1 0-.5 0-.5l.1.2.1.1.2.2v.4zm.7.5v-.2q.1-.4.3-.4v.2h.3v.3h.1q-.2.4-.4.3zm-.6-1.1v-.3l.2.2.1.2v.2zm.7 0v-.3.1q-.4.1-.3.2v.2q.3.1.3-.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "m23.5 19.1.1-.3.1.2q.2.1.2.3v.2q-.4-.1-.4-.4m.8 0v-.2za.3.3 0 0 0-.4.2v.2zm.3.8.2-.2h-.5l-.1.2q.3.2.4 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#006300",
    d: "M24.6 20h.2zq-.2-.2-.3-.1h-.1q0 .3.3.2m-.7-1.2.2-.6v.3l.4-.2v.1h.2l-.3.4h-.2l-.2.2zm.4.8h.3l.3-.2V19l-.3.1v-.2l-.1.1-.2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00863d",
    d: "M24.2 20.6h.1v-.1h.2-.1zh.2q.2-.1.3-.4l-.3.1zm-.4.6-.1-.3v.2zq0-.2-.3-.5v.4zm0-1.8h-.1v-.1zV19l-.2-.1v-.1.4zm.3-.7h.1v-.1l.2-.2v.1l-.1.1zh.1l.2-.2v-.3l-.2.2zm-.8 1.2-.1-.3v.1zv-.3l-.2-.1v-.1q-.2.1 0 .4zm.6-.5.2-.1v-.1l.1-.1v.1H24zh.1l.2-.1.1-.3-.2.1zm-.4.8h-.2l-.1-.1h.1zl-.2-.1H23l.1.2zm0 .6-.1-.2-.3-.1.1.2q0 .2.2.1m.1-.7-.1-.4v.2zv-.3l-.2-.2v.4zm.2.5v-.4zq.2-.2.1-.3V20l-.1.1zm.2-1.7v-.3zl.1-.3v-.3l-.1.1zm-1 2h.2l.2.2h.2V21h-.3v-.1h.2zm.2.3.2.2h.4-.4.1l-.1-.1.4.1h-.1q-.2-.2-.5-.2m1.2-1.7v-.3zl.1-.2V19l-.1.2zm-.2 2 .2-.1h.1zl.1.1.2-.2v-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00863d",
    d: "M24.2 20.6v-.2h.2V20l-.1.1-.1.1zm0 .9.1-.3zh.1l.1-.1V21l-.2.2zm.3-.8h.1-.4.1v.1h.3l.2-.2zm-1.3-.4.4.2h-.2v-.1h.3l-.2-.1zm.9 1.1v-.2zV21l-.1.3zm.4-2.8-.2.2q.3 0 .4-.4-.3 0-.2.2m0 .9v-.1h.2v-.2zv-.3l.3-.1v.2zm-.7.4-.1-.2v-.2.3-.2l-.1-.2v.3l.1.1m0 0 .2-.2.1-.1-.1.1h-.1l.1-.2h.2v.2zm.5 0h.2v-.1h.1-.4q.1.2.3.1l.3-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00863d",
    d: "M24.5 20h.1zh-.2zh.2zm0 1-.1-.1H24h.4m0 0v.2h.2zm-.3 0h.2zm.6-1.6h-.2l-.2.1zl.1-.2zm-.4 2.9v.2l.2.1h.2l-.1-.1h-.1v-.1h.1v.1h.3l-.2-.2zm.1-.2v-.4h.1v.3-.4l.1-.1h-.1l-.2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00863d",
    d: "M24.5 22.8h.4l.1-.2-.1.2h-.1v-.1h.3q-.1-.1-.4 0zm.9-.2v-.2zq.2 0 0-.3l-.1-.2v.4m-1-.2H24v-.1h.2l-.1-.1H24v.1zm-.7-.6.1.2h.3-.2v-.1zh.2l.1.2v-.2zm.8.3-.2-.3.1.1v-.2l-.1-.2v.4zm.7.7v-.1h.2l-.3-.2v.2zm-.2-.3-.1-.2v-.1zl-.1-.2-.3-.2v.1l.2.1zm.7.1v.2zv-.3zm-1-.6h.2zq.2.1.3-.1h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M26 23.5h.1v.2h.3v-.3H26m2 0v.2l-.3-.1v-.3l.2.1zm-1.5.3h.5l.1-.1.3.1.2-.1v-.3h-1.2v.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m27.1 23.5.4.2h-.1zm-.2 0-.4.2h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#aa241e",
    d: "M27 23.3q-.3 0-.1.2v.1h.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.1 23.4.5-.1m-.5.2q.6 0 .4.1m-.6-.1-.4.1m.3-.2h-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m25.2 22.8-.6.3-.3-.4-.2-.2H24l-.4-.5-.1-.1v.4h-.2l-.2-.1.4.5q0 .3.3.5l.2.2h.2l.3.4.7.2.2-.1q.4-.3.1-.4l.6-.2h2l.6.2v.2l.1.2h.5q.3 0 .4-.2.2-.1.3-.4h.4l.3-.6.4-.5-.5.1.1-.2v-.3l-.2.4-.2.2v.2q-.5-.1-.8.5l-1.3-.4H26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m24.7 23.8.2-.2 1.4-.4h1q.9 0 1.8.4l.1.2.3-.3v-.3l-.7-.3a7 7 0 0 0-3.6 0l-.7.3v.3l.1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m23.7 22.9.2.1.5.7.2.2h.7l.1-.1v-.2l-.3.2q-.3.2-.4 0l-.2-.3V23l-.1-.2q0-.2-.2-.3h-.3l-.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m23.5 22.4-.2-.1h-.2.1l.3.6.3.4h.2l-.1-.1-.2-.1v-.4l.1-.1-.1-.3-.3-.3v.2zm2 1.2-.1-.1-.5.2-.1.1q.2.2.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M24 23.3v-.1l-.3-.2v-.1q.4.2.4.4m6.3-.4-.2.1-.5.7-.2.2h-.7l-.1-.1v-.2l.3.3h.4l.2-.4V23l.1-.2.2-.3h.3l.1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m30.5 22.4.2-.1h.2-.1l-.3.6q0 .3-.3.4H30l.1-.1.2-.1v-.4l-.1-.1.1-.3.3-.3v.2zm-2 1.2.1-.1.5.2.1.1q-.2.2-.5-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M30 23.3v-.1l.3-.1v-.2c-.2 0-.4.4-.4.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "m25.1 23-.1.1v.2h.2zm0 .1v.1m.1 0v.2h.2V23zh.1V23zm.4-.2h-.1v.3l.1-.1zm0 0v.2l-.1-.1m.2 0v.2zh-.1v.1h.2zm.2 0h-.1v.2h.2zm0 .1v.1zm.1-.2v.2h.2V23zm.3 0v.2zm.3.2h-.1V23h-.1v.2zm.1-.2v.2h-.1.1zm0 0v.1m.3 0v.2h.1v-.2m0 0v.2zm.3 0v.2h.1zm0 0v.2zm.1.3v-.2zh.1v-.1.2h.1v-.3.1-.1h-.1v.2zm.3 0v-.2zm0 0h.1V23l.1.1v-.2.1-.1zm.3-.2v.2zm.1.2v.1h.1zV23h.1-.1m.3-.1v.1l-.1.1h.1zm0 0v.2zm.1.3V23zv.1zl.1-.1v.1l-.1-.2zm.3-.2v.1l-.1.1h.1v.1zm0 0v.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.2 18.1v3l.1.7.5.3h.7q.4 0 .5.2.2-.2.6-.2h.6q.3 0 .4-.3t.2-.7v-3l.5-.5h-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M26.6 19.5v-1.9h-1.9l.5.5v1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M27.4 19.5v-1.9h1.9l-.5.6v1.3zm-.8.7h-1.4v1.2q.1.7.7.7h.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M27.4 20.2h1.4v1.2q-.1.7-.8.7h-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.1,
    d: "M25.2 18.1v3l.1.7.5.3h.7l.4.1.1.1.2-.2h1q.3 0 .4-.3.3-.3.2-.7v-3l.5-.5h-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "M27 18v.3h-.3v.2h.2v.7h.2v-.7h.2v-.2h-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.7 18.4v.3l-.1-.2V21q0 .6.6.7t.5-.7v-1.2l-.1-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M25.7 18.4v.3l-.1-.1v1.3l.6.6V19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m26.4 19.2.2.2v.1l-.2-.2m.3.5v.9h-.2v-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M26.7 21h-.3l.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m25.6 20.3.6.5c0 .6.4.4.5.3q-.1.5-.5.5t-.6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.6 19.5-.9-1.1v.3zm-1-1V21q0 .6.6.7t.5-.7v-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "M26 18.1V18l-.2-.3v.3zm-.2-.4.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 18.1V18l-.2-.3v.3zm0 0-.2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "M27 19.6h-.1l-1-1.5h.1zm-1.3-1.4q-.2 0 0-.2l-.3-.2v.3zm-.3-.4.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7 18.2q-.2 0 0-.2l-.3-.2m.3.4h-.2l-.1-.4m.3.4-.3-.4m.6.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "m26.7 19.5-1.1-1.3zm-1.1-1v-.2l-.3-.1.1.3zm-.3-.3.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25.3 18.2.2.1.1.2h-.2zm0 0 .3.3m0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "m26.8 19.8-1.3-1.3zm-1.3-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.3 18.4v.3l.1-.2V21q0 .6-.6.7t-.5-.7v-1.2l.1-.1v-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M28.3 18.4v.3l.1-.1v1.3l-.6.6V19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m27.6 19.2-.1.2v.1l.1-.2m-.3.5v.9h.2v-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M27.3 21h.3l-.3-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m28.4 20.3-.6.5c0 .6-.4.4-.5.3q.1.5.5.5.6 0 .6-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.5 19.5.8-1.1v.3zm1-1V21q0 .6-.7.7-.5 0-.5-.7v-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "M28 18.1V18l.2-.3v.3zm.2-.4-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 18.1V18l.2-.3v.3zm0 0 .2-.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "M27 19.6h.1l1-1.5H28zm1.4-1.4V18l.2-.2v.3zm.2-.4-.2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4 18.2V18l.2-.2m-.2.4h.1l.1-.4m-.2.4.2-.4m-.5.3H28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "m27.3 19.5 1.1-1.3zm1.1-1q.2 0 0-.2l.3-.1-.1.3zm.3-.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.7 18.2-.2.1v.2h.1zm0 0-.3.3m0-.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eac102",
    d: "m27.3 19.8 1.2-1.3zm1.2-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "M26.8 20.6v.8l-.2-.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M26.8 20.6v.2l.1-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "M26.8 21.6h.3q.3-.2.2-.3l-.1-1-.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002d62",
    d: "m26.8 21.6.1.1.2-.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ce1126",
    d: "m27 20.5-.1.7h.2V21q.4-.1.3-.2l-.1-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2 21h-.3v.1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.1 21.5v-1.1l.1-.1.1 1q-.1.3-.2.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m26.2 19.7.5 1 1-.8-.5-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.2 19.7 1-.6.6.8-1 .7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "m26.7 20.5 1-.6v-.1l-.5-.7-.4.3-.5.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m26.8 19.4-.4.2h-.1l.4.8q.2 0 .3-.2h.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.8 19.4q0-.2.3-.3V19l.6.8-.3.2-.1.2zm-.1 1-.5-.8.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M26.5 19.7h.1m.1 0h.1m.1.2h.1m.2 0v-.1m0 0v-.1m-.2.3h.1m.2-.8h.1m.1.2v-.1m0 0h.1m.2.3v-.1m.2-.1v-.1m0 0v-.1m-.1.1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDo);
export default __webpack_public_path__ + "static/media/do.deca6845c319379923e9156b3efe5249.svg";
export { ForwardRef as ReactComponent };